import { SVGDone } from '~/shared/ui/SVG/SVGDone'

export const HonestSignBadge = () => {
  return (
    <span
      aria-label="Честный знак"
      className="relative inline-block h-5 w-5 rounded-lg bg-yellow-400"
      role="img"
    >
      <span className="absolute bottom-px left-0.5">
        <SVGDone color="black" size="17px" />
      </span>
    </span>
  )
}
